import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class TeekoState extends PlayerOrNoneGameStateWithTable {
    static WIDTH = 5;
    isInDropPhase() {
        return this.turn < 8;
    }
}
